import src from "IMAGE";
export default { src, width: 1205, height: 168, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAHklEQVR42mNgYGAoB+JUIC4E4jAgjgfiBiCuBOI0ADKKA2Ij+iwoAAAAAElFTkSuQmCC"};
